import anime from "animejs/lib/anime.es";
import {isInViewport} from "./index";

const logos = document.querySelectorAll<HTMLElement>('.klant-item img');

const elements: { selector: string, distance: number, speed: number }[] = [
    {
        selector: '.home-title,.archive-diensten-page h1, h1',
        distance: 10,
        speed: 0
    },
    {
        selector: '.home-image',
        distance: 3,
        speed: 0
    },
    {
        selector: '.single-diensten-page .quote',
        distance: 5,
        speed: 0
    },
];

let mouseX = 0;
let mouseY = 0;

document.addEventListener('mousemove', handleMouseMove);

function handleMouseMove(event: MouseEvent) {
    mouseX = event.clientX;
    mouseY = event.clientY;
    document.body.style.setProperty('--mouse-x', `${mouseX}px`);
    document.body.style.setProperty('--mouse-y', `${mouseY}px`);
}

function animateLogos() {
    if (mouseX && mouseY) {
        logos.forEach((logo: HTMLElement) => {
            if (logo && isInViewport(logo)) {
                const logoRect = logo.getBoundingClientRect();
                const logoX = logoRect.left + logoRect.width / 2;
                const logoY = logoRect.top + logoRect.height / 2;
                const distanceX = mouseX - logoX;
                const distanceY = mouseY - logoY;
                const distance = Math.sqrt(distanceX ** 2 + distanceY ** 2);
                const scale = (distance <= 250) ? 1.1 : 1;

                anime({
                    targets: logo,
                    scale: scale,
                    duration: 100,
                    easing: 'linear'
                });
            }
        });
    }
}

function moveOnMouse(target: HTMLElement | null, distance: number, speed: number) {
    if (target && isInViewport(target)) {
        const windowWidth = window.innerWidth;
        const windowHeight = window.innerHeight;
        const moveX = (mouseX / windowWidth - 0.5) * 2 * distance;
        const moveY = (mouseY / windowHeight - 0.5) * 2 * distance;

        anime({
            targets: target,
            translateX: -moveX,
            translateY: -moveY,
            duration: speed,
            easing: 'easeInQuad'
        });
    }
}

function animateElements() {
    if (window.innerWidth > 991) {
        elements.forEach((element) => {
            const target = document.querySelector<HTMLElement>(element.selector);
            if (target) {
                moveOnMouse(target, element.distance, element.speed);
            }
        });
    }
}

function onWindowChange() {
    window.addEventListener('resize', () => {
        if ((window.innerWidth < 992)) {
            elements.forEach((element) => {
                const target = document.querySelector<HTMLElement>(element.selector);
                if (target) {
                    target.style.removeProperty("transform");
                }
            });
        }
    });
}


function optimizePage() {
    animateLogos();
    animateElements();
    requestAnimationFrame(optimizePage);
    onWindowChange();
}

optimizePage();
